/**
 * One site's "are these readings now?" for any screen (`lib/site-liveness.ts` has the rule). Read off
 * the fleet health every screen already shares — the same cache entry as the header's site context
 * and the Overview, so asking here costs no request.
 */
import { useMemo } from 'react';
import { useSiteHealth } from '@/lib/api/queries';
import type { SiteHealth } from '@/lib/api/types';
import { livenessOf, type Liveness } from '@/lib/site-liveness';

export function useSiteLiveness(siteId: string | null | undefined): { liveness: Liveness; health: SiteHealth | null } {
  const q = useSiteHealth();
  return useMemo(() => {
    const health = siteId ? (q.data?.data.find((h) => h.siteId === siteId) ?? null) : null;
    return { liveness: livenessOf(health), health };
  }, [q.data, siteId]);
}
